'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validator = require('validator');

var isPostalCode = function isPostalCode(value) {
  return value && (0, _validator.isPostalCode)(value, 'any') ? undefined : 'Please check your post code';
};

exports.default = isPostalCode;